import holdedIcon from '@/assets/img/icons/erp/holded.png'
export const erpConfigItems = [
  {
    id: 1,
    integrationName: 'holded',
    integrationOfficeConfigKey: 'HOLDED_ERP'
  }
]
export const erpIcons = [
  { id: 1, integrationKey: 'HOLDED_ERP', integrationIcon: holdedIcon }
]

export const erpOfficeConfigurationData = [
  { id: 1, officeConfigKey: 'HOLDED_ERP', integrationName: 'holded', integrationIcon: holdedIcon, config: { paymentAccountNumber: null } }
]
